import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor(
    private apiService: ApiService,
  ) { }


  accountSetup(data: any) {
    return this.apiService.doRequest('api/forms/store', 'POST', {
      name: "ACCOUNT_SETUP",
      data: data
    });
  }

  skipSetup() {
    return this.apiService.doRequest('api/users/skip-setup', 'POST', {});
  }
}
